class BeforeAfterSlider extends HTMLElement {
  connectedCallback() {
    this.sliders = this.querySelectorAll('[data-ba-slider]');
    this.sliders.forEach((slider) => this.initSlider(slider));
  }

  initSlider(slider) {
    const beforeImg = slider.querySelector('[data-ba-before]');
    const divider = slider.querySelector('[data-ba-divider]');
    const handle = slider.querySelector('[data-ba-handle]');

    if (!beforeImg || !divider || !handle) return;

    let isDragging = false;

    const getPosition = (e) => {
      const rect = slider.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const x = clientX - rect.left;
      return Math.max(0, Math.min(x / rect.width, 1));
    };

    const updateSlider = (ratio) => {
      const pct = ratio * 100;
      beforeImg.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      divider.style.left = pct + '%';
      handle.style.left = pct + '%';
    };

    const onStart = (e) => {
      isDragging = true;
      updateSlider(getPosition(e));
    };

    const onMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      updateSlider(getPosition(e));
    };

    const onEnd = () => {
      isDragging = false;
    };

    slider.addEventListener('mousedown', onStart);
    slider.addEventListener('touchstart', onStart, { passive: true });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  }
}

customElements.define('before-after-slider', BeforeAfterSlider);
